const metricsReducer = (state = { lastEntries: {}, sensors: {} }, action) => {
  switch (action.type) {
    case 'SET_LAST_ENTRIES': {
      const { lastEntries, timeSinceLastReading, systemId } = action.payload;
      return {
        ...state,
        lastEntries: {
          ...state.lastEntries,
          [systemId]: {
            systemMetrics: lastEntries,
            timeSinceLastReading,
            loading: false,
            error: false
          }
        }
      };
    }
    case 'SET_LAST_ENTRIES_LOADING': {
      const { systemId } = action.payload;
      return {
        ...state,
        lastEntries: {
          ...state.lastEntries,
          [systemId]: {
            ...state.lastEntries[systemId],
            loading: true,
            error: false
          }
        }
      };
    }
    case 'SET_LAST_ENTRIES_ERROR': {
      const { systemId } = action.payload;
      return {
        ...state,
        lastEntries: {
          ...state.lastEntries,
          [systemId]: {
            ...state.lastEntries[systemId],
            loading: false,
            error: true
          }
        }
      };
    }
    case 'SET_SENSOR_METRICS': {
      const { metrics, sensorId, timePreset } = action.payload;
      return {
        ...state,
        sensors: {
          ...state.sensors,
          [sensorId]: {
            ...state.sensors[sensorId],
            [timePreset.name]: { metrics, loading: false, error: false }
          }
        }
      };
    }
    case 'SET_SENSOR_METRICS_LOADING': {
      const { sensorId, timePreset } = action.payload;
      const oldValues = state.sensors[sensorId]
        ? state.sensors[sensorId]
        : { [timePreset]: {} };

      return {
        ...state,
        sensors: {
          ...state.sensors,
          [sensorId]: {
            ...state.sensors[sensorId],
            [timePreset.name]: {
              ...oldValues,
              loading: true,
              error: false
            }
          }
        }
      };
    }
    case 'SET_SENSOR_METRICS_ERROR': {
      const { sensorId, timePreset } = action.payload;
      const oldValues = state.sensors[sensorId]
        ? state.sensors[sensorId]
        : { [timePreset]: {} };

      return {
        ...state,
        sensors: {
          ...state.sensors,
          [sensorId]: {
            ...state.sensors[sensorId],
            [timePreset.name]: {
              ...oldValues,
              error: true
            }
          }
        }
      };
    }
    default:
      return state;
  }
};

export default metricsReducer;
